import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL } from 'lib-base';

@Injectable({
  providedIn: 'root'
})
export class TramSegDocumentoService {
  readonly baseUrl: string;

  constructor(@Inject(API_URL) public apiUrl: string, private readonly http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/tram-seg-documento`;
  }

  public downloadFormFile(id: number): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/descargar/${id}`, { responseType: 'blob' });
  }


}
